<template>
  <div>
    <div
      v-show="isMask"
      class="resizer-mask"
      ref="resizerMask"
      :style="{ top: maskTop + 'px' }"
    ></div>
    <div
      :class="['resizer-drag']"
      :style="{ top: dragTop + 'px' }"
      ref="resizer"
      @mousedown.prevent="mouseDown"
    >
      <p>拖拽</p>
    </div>
  </div>
</template>

<script>
import { getPageSize } from "e6-base-map/utils/map/e6Common.js";
export default {
  name: "e6Resizer",
  props: {
    top: {
      type: Number,
      default: 0
    },
    min: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      isMask: false,
      clickTop: 0, // 点击时的 top
      dragTop: 0, // 拖拽层的 top
      dy: 0
    };
  },
  watch: {
    top: {
      handler(val) {
        this.dragTop = val;
      }
    }
  },
  mounted() {
    this.dragTop = this.top;
  },
  computed: {
    maskTop() {
      return this.dragTop + 6;
    }
  },
  methods: {
    mouseDown(ev) {
      var iEvent = ev || event;
      this.dy = iEvent.clientY; //当你第一次单击的时候，储存Y轴的坐标。
      this.isMask = true;
      this.clickTop = this.dragTop;
      document.addEventListener("mousemove", this.mouseMove);
      document.addEventListener("mouseup", this.mouseUp);
    },
    mouseMove(ev) {
      if (this.isMask) {
        var iEvent = ev || event;
        var toTop = this.clickTop + (iEvent.clientY - this.dy);
        var pageHeight = getPageSize().pageHeight;
        if (toTop + 50 + this.min >= pageHeight) return;
        this.dragTop = toTop <= 0 ? 0 : toTop;
      }
    },
    mouseUp() {
      this.isMask = false;
      this.$emit("move", this.dragTop);
      document.removeEventListener("mousemove", this.mouseMove);
      document.removeEventListener("mouseup", this.mouseUp);
    }
  }
};
</script>

<style lang="scss" scoped>
.resizer-mask {
  width: 100%;
  background-color: #e0f2fd;
  opacity: 0.6;
  bottom: 0;
  position: absolute;
  z-index: 9999999;
  box-sizing: border-box;
}
.resizer-drag {
  height: 6px;
  width: 100%;
  background-color: #eaeaea;
  display: flex;
  flex-direction: row;
  justify-content: center;
  z-index: 5;
  position: absolute;
  p {
    margin: 0;
    height: 5px;
    background: url("../img/icon_drag.png") no-repeat 50% 0;
    overflow: hidden;
    text-indent: -9999px;
  }
}
.animation-r {
  transition: all 0.3s ease;
  -moz-transition: all 0.3s ease; /* Firefox 4 */
  -webkit-transition: all 0.3s ease; /* Safari and Chrome */
  -o-transition: all 0.3s ease; /* Opera */
}

.resizer-drag:hover {
  cursor: ns-resize;
  background-color: #b7d0e0;
}
</style>
